import { Withdrawal } from "@widgets/wallet";
import { FC } from "react";

export const WithdrawalPage: FC = () => {
  return <Withdrawal />;
};
